import {useRef} from 'react';
import {Modal} from '@cvent/carina/components/Modal';
import {Button} from '@cvent/carina/components/Button';
import {DismissButton} from '@cvent/carina/components/ScrollViewWithBars';

type ReactivatePlanModalProps = {
  handleClose: () => void;
  onConfirm: () => void;
};

const ReactivatePlanModal = ({
  handleClose,
  onConfirm,
}: ReactivatePlanModalProps) => {
  const headerRef = useRef<HTMLHeadingElement | null>(null);

  return (
    <Modal
      isOpen
      format="md"
      onDismiss={handleClose}
      testID="reactivate-plan-modal"
      aria-labelledby="reactivate-plan-title"
    >
      <div className="flex flex-col box-border p-6 pt-4">
        <div className="mb-4 flex items-start justify-between">
          <h1
            id="reactivate-plan-title"
            ref={headerRef}
            tabIndex={-1}
            className="text-[length:var(--carina-font-size-display-xs)] font-[var(--carina-font-weight-display)] leading-[var(--carina-line-height-display-xs)] pt-1"
          >
            Would you like to reactivate your plan?
          </h1>
          <DismissButton aria-label="Dismiss" onClick={handleClose} />
        </div>
        <div className="mt-4 flex justify-end gap-4">
          <Button
            text="Cancel"
            onClick={handleClose}
            type="button"
            appearance="lined"
          />
          <Button
            text="Reactivate plan"
            onClick={onConfirm}
            type="button"
            appearance="filled"
          />
        </div>
      </div>
    </Modal>
  );
};

export default ReactivatePlanModal;
